import React, { useState, useEffect, useContext } from 'react'
import ApiService from '../../services/ApiService'
import close from '../../assets/close-icon.svg'
import plus from '../../assets/productions/plus.svg'
import ModalContext from '../../contexts/ModalContext'
import { contactInputs, sectionsInModal } from './utils'
import DisponibilityComponent from './DisponibilityComponent'
import SelectFunctionsComponent from './SelectFunctionComponent'
import SelectTypeComponent from './SelectTypeComponent'
import InsertCEPComponent from './InsertCEPComponent'
import { FeedbackContext } from '../../contexts/FeedbackContext'
import ModalTest from '../BaseModal'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import ConfirmationModal from '../ModalConfirmation'
import { Plus, Save } from 'lucide-react'
import { OptionsContainer } from '../selectSearch/selectOptions/style'
import { getSearchParamsForLocation } from 'react-router-dom/dist/dom'
import UserSelect from '../../pages/ClientPanel/Equipment/Select/UserSelect'
import {
  Container, Header, CloseDiv, SwitchDiv, InputLabel, SwitchBox,
  SwitchInput, SwitchSlider, FormDataDiv, SectionDiv, InputDiv, InputData,
  LineContainer, ContactsContainer, EmptyContactsMessage, ContactCard,
  ContactHeader, ContactName, ContactInfo, ContactField, ContactLabel, LinkedUsersTagsContainer,
  ContactValue, BottomDiv, ButtonContainer, ButtonDiv, LinkedUserTag, SectionHeaderRow,
  SectionTitle, CompactUserSelectWrap
} from './style'
import { ContactInterface, CompanyInterface, functionsType, LinkedUserInterface, typesInterface } from './types'

const AddCompanyModal: React.FC = () => {
  const { setModalActive } = useContext(ModalContext)
  const { setFeedback, setNewCompanies } = useContext(FeedbackContext)
  const [newContact, setNewContact] = useState<boolean>(false)
  const [legalPerson, setLegalPerson] = useState<boolean>(true)
  const [autoAddress, setAutoAddress] = useState({ state: false, city: false, neighborhood: false, street: false })
  const [searchParam] = useSearchParams();
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const legalPersonInputs = ['stateRegistration', 'cnpj', 'companyName']
  const [contactForm, setContactForm] = useState<ContactInterface>({
    name: '',
    email: '',
    phone: '',
    companyId: 0
  })
  const [formData, setFormData] = useState<CompanyInterface>({
    cnpj: '',
    cpf: '',
    companyName: '',
    stateRegistration: '',
    contacts: [],
    linkedUsers: [],
    contactName: '',
    email: '',
    phone: '',
    activedDays: [],
    startTime: '08:00',
    endTime: '18:00',
    functions: [],
    companyTypes: { typeName: '', id: 0 },
    cep: '',
    state: { id: 0, name: '' },
    city: { id: 0, name: '' },
    neighborhood: { id: 0, name: '' },
    street: '',
    complement: '',
    number: ''
  })
  const companyId = searchParam.get('id')
  const [showConfirm, setShowConfirm] = useState<boolean>(false)
  const [deleteError, setDeleteError] = useState<string | null>(null)
  const [userSelectKey, setUserSelectKey] = useState<number>(0)

  useEffect(() => {
    const getCompany = async () => {

      console.log('🛰️ [FRONT] getCompany chamado com id:', companyId)
      const response = await ApiService.companies.findById(Number(companyId))

      console.log('🛰️ [FRONT] resposta getCompany:', response?.status, response?.data)

      if (response && response.data) {
        const company = response.data
        const rawCompanyTypes = Array.isArray(company.companyTypes) ? company.companyTypes : []

        const flattenedTypes = rawCompanyTypes.map((ct: any) => {
          const id = ct?.companyType?.id ?? ct?.companyTypeId ?? ct?.id ?? ct
          const typeName = String(ct?.companyType?.typeName ?? ct?.typeName ?? '').trim()
          return { id, typeName }
        }).filter((ct: any) => ct.id !== undefined && ct.id !== null)

        const numericIds = flattenedTypes
          .map((ct: any) => Number(ct.id))
          .filter((id: number) => !Number.isNaN(id) && id > 0)

        const uniqueIds = Array.from(new Set(numericIds))
        const uniqueNames = Array.from(new Set(flattenedTypes.map((ct: any) => ct.typeName).filter((n: string) => n.length > 0)))

        const normalizedCompanyTypes: typesInterface = uniqueIds.length > 1
          ? { typeName: 'Ambos', id: uniqueIds as number[] }
          : {
            typeName: String(uniqueNames.length >= 1 ? uniqueNames[0] : ''),
            id: uniqueIds.length === 1 ? Number(uniqueIds[0]) : 0
          }

        console.log('🛰️ [FRONT] rawCompanyTypes:', rawCompanyTypes)
        console.log('🛰️ [FRONT] flattenedTypes:', flattenedTypes)
        console.log('🛰️ [FRONT] uniqueIds:', uniqueIds)
        console.log('🛰️ [FRONT] uniqueNames:', uniqueNames)
        console.log('🛰️ [FRONT] normalizedCompanyTypes:', normalizedCompanyTypes)

        const rawCepValue = String(company.cep ?? company.address?.cep ?? '').replace(/\D/g, '')
        const paddedCep = rawCepValue ? rawCepValue.padStart(8, '0') : ''

        const normalizedCompanyForForm = {
          cnpj: company.cnpj || '',
          cpf: company.cpf || '',
          companyName: company.companyName || '',
          stateRegistration: company.stateRegistration || '',
          contacts: company.contacts || [],
          linkedUsers: Array.isArray(company.linkedUsers)
            ? company.linkedUsers
              .filter((user: any) => user?.id)
              .map((user: any) => ({ id: Number(user.id), name: String(user.name || '').trim() }))
              .filter((user: LinkedUserInterface) => user.name.length > 0)
            : [],
          contactName: company.contactName || '',
          email: company.email || '',
          phone: company.phone || '',
          activedDays: company.activedDays || [],
          startTime: company.startTime,
          endTime: company.endTime,
          functions: company.functions || [],
          companyTypes: normalizedCompanyTypes || { typeName: '', id: 0 },
          cep: paddedCep,
          state: { id: company.state?.id || 0, name: company.state?.name || '' },
          city: { id: company.city?.id || 0, name: company.city?.name || '' },
          neighborhood: { id: company.neighborhood?.id || 0, name: company.neighborhood?.name || '' },
          street: company.street || '',
          complement: company.complement || '',
          number: company.number || ''
        }

        console.log('🛰️ [FRONT] normalizedCompanyForForm:', normalizedCompanyForForm)
        console.log('🛰️ [FRONT] raw company.companyTypes:', company.companyTypes)

        setFormData(normalizedCompanyForForm)

        setAutoAddress({ state: false, city: false, neighborhood: false, street: false })

        if (company.cnpj || (company.companyName && company.companyName.trim())) {
          setLegalPerson(true)
        } else {
          setLegalPerson(false)
        }

      }
    }
    if (companyId) {
      getCompany()

    }
  }, [])

  const handleEditForm = (e: any, field: keyof CompanyInterface) => {
    if (field === 'state') {
      setAutoAddress(prev => ({ ...prev, state: false, city: false, neighborhood: false }))
      return setFormData(prev => ({
        ...prev,
        state: { id: 0, name: e.target.value },
        city: { id: 0, name: prev.city.name },
        neighborhood: { id: 0, name: prev.neighborhood.name }
      }))
    }
    if (field === 'city') {
      setAutoAddress(prev => ({ ...prev, city: false, neighborhood: false }))
      return setFormData(prev => ({
        ...prev,
        city: { id: 0, name: e.target.value },
        neighborhood: { id: 0, name: prev.neighborhood.name }
      }))
    }
    if (field === 'neighborhood') {
      setAutoAddress(prev => ({ ...prev, neighborhood: false }))
      return setFormData(prev => ({
        ...prev,
        neighborhood: { id: 0, name: e.target.value }
      }))
    }
    if (field === 'street') {
      setAutoAddress(prev => ({ ...prev, street: false }))
    }
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }))
  }

  const handleViewValue = (field: keyof CompanyInterface) => {
    if (field === 'state' || field === 'city' || field === 'neighborhood')
      return formData[field].name

    return formData[field]
  }

  const maskCNPJ = (value: any) => {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .slice(0, 18)
  }

  const maskCPF = (value: any) => {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2')
      .slice(0, 14)
  }

  const maskPhone = (value: any) => {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4,5})(\d{4})$/, '$1-$2')
      .slice(0, 15)
  }

  const formatCep = (value: string) => {
    const raw = (value || '').replace(/\D/g, '')
    const digits = raw ? raw.padStart(8, '0').slice(0, 8) : ''
    return digits.replace(/^(\d{5})(\d)/, '$1-$2')
  }

  const handleNewContact = () => {
    setNewContact(true)
  }

  const handleAddContact = () => {
    console.log('🛰️ [FRONT] handleAddContact', contactForm)
    setFormData(prev => ({
      ...prev,
      contacts: [
        ...prev.contacts,
        {
          name: contactForm.name,
          email: contactForm.email,
          phone: contactForm.phone,
          companyId: companyId ? parseInt(companyId) : 0
        }
      ]
    }))
    setContactForm(
      {
        name: '',
        email: '',
        phone: '',
        companyId: 0
      }
    )
    setNewContact(false)
  }

  const handleEditContat = (field: string, value: string) => {
    setContactForm((prevData) => ({
      ...prevData,
      [field]: value
    }))
  }

  const handleRemoveContact = (index: number) => {
    setFormData(prev => ({
      ...prev,
      contacts: prev.contacts.filter((_, i) => i !== index)
    }))
  }

  const handleAddLinkedUser = (user: any | null) => {
    if (!user?.id || !user?.name) return

    setFormData(prev => {
      const alreadyLinked = prev.linkedUsers.some(linkedUser => linkedUser.id === user.id)
      if (alreadyLinked) return prev

      return {
        ...prev,
        linkedUsers: [...prev.linkedUsers, { id: Number(user.id), name: String(user.name).trim() }]
      }
    })

    setUserSelectKey(prev => prev + 1)
  }

  const handleRemoveLinkedUser = (id: number) => {
    setFormData(prev => ({
      ...prev,
      linkedUsers: prev.linkedUsers.filter(user => user.id !== id)
    }))
  }

  const handleDeleteConfirm = async () => {
    if (!companyId) return
    try {
      await ApiService.companies.delete(Number(companyId))
      setShowConfirm(false)
      setModalActive(false)
      setNewCompanies?.(prev => prev + 1)
      queryClient.invalidateQueries({ queryKey: ['companies'] })
      setFeedback({ isOpen: true, message: 'Empresa excluída com sucesso!', statusOk: true })
      navigate('..')
    } catch (error: any) {
      console.error('Erro ao excluir empresa:', error)
      const msg = error?.response?.data?.message || error?.response?.data?.error || 'Não foi possível excluir a empresa. Ela pode possuir relações com outros registros.'
      setDeleteError(msg)
      setShowConfirm(true)
    }
  }

  const handleEdit = () => {
    if (formData.cnpj.trim() && !formData.companyName.trim()) {
      setFeedback({
        isOpen: true,
        message: 'Quando CNPJ é preenchido, a razão social é obrigatória.',
        statusOk: false
      })
      return
    }

    if (formData.cpf.trim() && !formData.contactName.trim()) {
      setFeedback({
        isOpen: true,
        message: 'Quando CPF é preenchido, o nome da pessoa é obrigatório.',
        statusOk: false
      })
      return
    }

    if (!formData.cnpj.trim() && !formData.cpf.trim() && !formData.companyName.trim() && !formData.contactName.trim()) {
      setFeedback({
        isOpen: true,
        message: 'Preencha pelo menos um campo: CNPJ, CPF, Razão Social ou Nome.',
        statusOk: false
      })
      return
    }

    const computedLegalPerson = formData.companyName.trim()
      ? true
      : formData.contactName.trim()
        ? false
        : legalPerson;

    const dataToSend: any = {
      legalPerson: computedLegalPerson
    }
    const isPessoaJuridica = computedLegalPerson
    const isPessoaFisica = !computedLegalPerson

    if (isPessoaJuridica) {
      dataToSend.cnpj = formData.cnpj.trim()
      dataToSend.cpf = null
      dataToSend.companyName = formData.companyName && formData.companyName.trim() ? formData.companyName.trim() : null
      dataToSend.contactName = null
      dataToSend.stateRegistration = formData.stateRegistration && formData.stateRegistration.trim() ? formData.stateRegistration.trim() : null
    } else if (isPessoaFisica) {
      dataToSend.cpf = formData.cpf && formData.cpf.trim() ? formData.cpf.trim() : null
      dataToSend.cnpj = null
      dataToSend.contactName = formData.contactName && formData.contactName.trim() ? formData.contactName.trim() : null
      dataToSend.companyName = null
      dataToSend.stateRegistration = null
    } else {
      dataToSend.cnpj = null
      dataToSend.cpf = null
      dataToSend.companyName = formData.companyName && formData.companyName.trim() ? formData.companyName.trim() : null
      dataToSend.contactName = formData.contactName && formData.contactName.trim() ? formData.contactName.trim() : null
      if (!dataToSend.companyName && dataToSend.contactName) {
        dataToSend.companyName = dataToSend.contactName
      }
      dataToSend.stateRegistration = formData.stateRegistration && formData.stateRegistration.trim() ? formData.stateRegistration.trim() : null
    }

    dataToSend.email = formData.email && formData.email.trim() ? formData.email.trim() : null
    dataToSend.phone = formData.phone && formData.phone.trim() ? formData.phone.trim() : null

    if (formData.activedDays.length > 0) {
      dataToSend.activedDays = formData.activedDays
    }
    if (formData.functions.length > 0) {
      dataToSend.functions = formData.functions
    }
    dataToSend.contacts = formData.contacts
    dataToSend.linkedUsers = formData.linkedUsers

    if (formData.startTime !== '08:00') {
      dataToSend.startTime = formData.startTime
    }
    if (formData.endTime !== '18:00') {
      dataToSend.endTime = formData.endTime
    }

    if (formData.companyTypes.id !== 0) {
      dataToSend.companyTypes = { id: Array.isArray(formData.companyTypes.id) ? formData.companyTypes.id : [formData.companyTypes.id] }
    }

    const hasValidAddress = formData.cep?.trim() ||
      formData.state?.name?.trim() ||
      formData.city?.name?.trim() ||
      formData.neighborhood?.name?.trim() ||
      formData.street?.trim() ||
      formData.number?.trim() ||
      formData.complement?.trim()

    if (hasValidAddress) {
      if (formData.cep?.trim()) dataToSend.cep = formatCep(formData.cep.trim())
      if (formData.state?.name?.trim()) dataToSend.state = formData.state
      if (formData.city?.name?.trim()) dataToSend.city = formData.city
      if (formData.neighborhood?.name?.trim()) dataToSend.neighborhood = formData.neighborhood
      if (formData.street?.trim()) dataToSend.street = formData.street.trim()
      if (formData.number?.trim()) dataToSend.number = formData.number.trim()
      if (formData.complement?.trim()) dataToSend.complement = formData.complement.trim()
    }

    console.log('🛰️ [FRONT] update company payload', dataToSend)
    ApiService.companies.update(Number(companyId), dataToSend)
      .then((response: any) => {
        setModalActive(false)
        setNewCompanies?.(prev => prev + 1)
        queryClient.invalidateQueries({ queryKey: ['companies'] })
        setFeedback({
          isOpen: true,
          message: 'Empresa atualizada com sucesso!',
          statusOk: true
        })
        navigate('..')
      })
      .catch((error: any) => {
        console.error('Erro ao atualizar empresa:', error)
        setNewCompanies?.(prev => prev + 1)
        setFeedback({
          isOpen: true,
          message: 'Erro ao atualizar empresa. Tente novamente.',
          statusOk: false
        })
      })
  }

  const handleSubmit = () => {
    if (formData.cnpj.trim() && !formData.companyName.trim()) {
      setFeedback({
        isOpen: true,
        message: 'Quando CNPJ é preenchido, a razão social é obrigatória.',
        statusOk: false
      })
      return
    }

    if (formData.cpf.trim() && !formData.contactName.trim()) {
      setFeedback({
        isOpen: true,
        message: 'Quando CPF é preenchido, o nome da pessoa é obrigatório.',
        statusOk: false
      })
      return
    }

    if (!formData.cnpj.trim() && !formData.cpf.trim() && !formData.companyName.trim() && !formData.contactName.trim()) {
      setFeedback({
        isOpen: true,
        message: 'Preencha pelo menos um campo: CNPJ, CPF, Razão Social ou Nome.',
        statusOk: false
      })
      return
    }

    const computedLegalPerson = formData.companyName.trim()
      ? true
      : formData.contactName.trim()
        ? false
        : legalPerson;

    const dataToSend: any = {
      legalPerson: computedLegalPerson
    }
    const isPessoaJuridica = computedLegalPerson
    const isPessoaFisica = !computedLegalPerson

    if (isPessoaJuridica) {
      dataToSend.cnpj = formData.cnpj.trim()
      dataToSend.cpf = null
      dataToSend.companyName = formData.companyName && formData.companyName.trim() ? formData.companyName.trim() : null
      dataToSend.contactName = null
      dataToSend.stateRegistration = formData.stateRegistration && formData.stateRegistration.trim() ? formData.stateRegistration.trim() : null
    } else if (isPessoaFisica) {
      dataToSend.cpf = formData.cpf && formData.cpf.trim() ? formData.cpf.trim() : null
      dataToSend.cnpj = null
      dataToSend.contactName = formData.contactName && formData.contactName.trim() ? formData.contactName.trim() : null
      dataToSend.companyName = null
      dataToSend.stateRegistration = null
    } else {
      dataToSend.cnpj = null
      dataToSend.cpf = null
      dataToSend.companyName = formData.companyName && formData.companyName.trim() ? formData.companyName.trim() : null
      dataToSend.contactName = formData.contactName && formData.contactName.trim() ? formData.contactName.trim() : null
      if (!dataToSend.companyName && dataToSend.contactName) {
        dataToSend.companyName = dataToSend.contactName
      }
      dataToSend.stateRegistration = formData.stateRegistration && formData.stateRegistration.trim() ? formData.stateRegistration.trim() : null
    }

    dataToSend.email = formData.email && formData.email.trim() ? formData.email.trim() : null
    dataToSend.phone = formData.phone && formData.phone.trim() ? formData.phone.trim() : null

    if (formData.activedDays.length > 0) {
      dataToSend.activedDays = formData.activedDays
    }
    if (formData.functions.length > 0) {
      dataToSend.functions = formData.functions
    }
    dataToSend.contacts = formData.contacts
    dataToSend.linkedUsers = formData.linkedUsers

    if (formData.startTime !== '08:00') {
      dataToSend.startTime = formData.startTime
    }
    if (formData.endTime !== '18:00') {
      dataToSend.endTime = formData.endTime
    }

    if (formData.companyTypes.id !== 0) {
      dataToSend.companyTypes = { id: Array.isArray(formData.companyTypes.id) ? formData.companyTypes.id : [formData.companyTypes.id] }
    }

    const hasValidAddress = formData.cep.trim() ||
      formData.state.name.trim() ||
      formData.city.name.trim() ||
      formData.neighborhood.name.trim() ||
      formData.street.trim() ||
      formData.number.trim() ||
      formData.complement.trim()

    if (hasValidAddress) {
      if (formData.cep.trim()) dataToSend.cep = formatCep(formData.cep.trim())
      if (formData.state.name.trim()) dataToSend.state = formData.state
      if (formData.city.name.trim()) dataToSend.city = formData.city
      if (formData.neighborhood.name.trim()) dataToSend.neighborhood = formData.neighborhood
      if (formData.street.trim()) dataToSend.street = formData.street.trim()
      if (formData.number.trim()) dataToSend.number = formData.number.trim()
      if (formData.complement.trim()) dataToSend.complement = formData.complement.trim()
    }

    console.log('🛰️ [FRONT] create company payload', dataToSend)
    ApiService.companies.create(dataToSend)
      .then((response: any) => {
        setModalActive(false)
        setNewCompanies?.(prev => prev + 1)
        queryClient.invalidateQueries({ queryKey: ['companies'] })
        setFeedback({
          isOpen: true,
          message: 'Empresa criada com sucesso!',
          statusOk: true
        })
        navigate('..')
      })
      .catch((error: any) => {
        console.error('Erro ao criar empresa:', error)
        setFeedback({
          isOpen: true,
          message: 'Erro ao criar empresa. Tente novamente.',
          statusOk: false
        })
      })
  }

  return (
    <ModalTest>
      <Container>
        <Header>
          <h2>Cadastrar Empresa</h2>
          <CloseDiv onClick={() => (navigate('..'))}>
            <img src={close} />
          </CloseDiv>
        </Header>

        <SwitchDiv>
          <InputLabel>Pessoa juridica</InputLabel>
          <SwitchBox>
            <SwitchInput
              type="checkbox"
              onChange={(e) => {
                const checked = e.target.checked
                setLegalPerson(checked)
                if (!checked) {
                  setFormData(prev => ({ ...prev, cnpj: '', companyName: '', stateRegistration: '' }))
                } else {
                  setFormData(prev => ({ ...prev, cpf: '' }))
                }
              }}
              checked={legalPerson} />
            <SwitchSlider className="slider"></SwitchSlider>
          </SwitchBox>
        </SwitchDiv>
        <FormDataDiv>
          {sectionsInModal.map((section, index) =>
            <SectionDiv key={index} className={section.className}>
              {section.inputs
                .filter((input) => {

                  if (legalPerson) {
                    if (input.value === 'cpf' || input.value === 'contactName') {
                      return false;
                    }
                    return true;
                  }

                  if (input.value === 'cnpj' || input.value === 'stateRegistration' || input.value === 'companyName') {
                    return false;
                  }
                  return true;
                })
                .map((input, index) =>
                  <InputDiv key={index}>
                    <InputLabel>{input.value === 'contactName' ? 'Nome' : input.label}</InputLabel>
                    {input.value === 'activedDays' ?
                      <DisponibilityComponent company={formData} setCompany={setFormData} />
                      : input.value === 'functions' ?
                        <SelectFunctionsComponent company={formData} setCompany={setFormData} />
                        : input.value === 'companyTypes' ?
                          <SelectTypeComponent company={formData} setCompany={setFormData} />
                          : input.value === 'cep' ?
                            <InsertCEPComponent company={formData} setCompany={setFormData} setAutoAddress={setAutoAddress} autoAddress={autoAddress} />
                            :
                            <InputData
                              type={input.type}
                              placeholder={input.placeholder}
                              readOnly={
                                (input.value === 'state' && autoAddress.state) ||
                                (input.value === 'city' && autoAddress.city) ||
                                (input.value === 'neighborhood' && autoAddress.neighborhood) ||
                                (input.value === 'street' && autoAddress.street)
                              }
                              onChange={(e) => {
                                const maskedValue = input.value === 'cnpj'
                                  ? maskCNPJ(e.target.value)
                                  : input.value === 'cpf'
                                    ? maskCPF(e.target.value)
                                    : input.value === 'phone'
                                      ? maskPhone(e.target.value)
                                      : e.target.value
                                handleEditForm({ target: { value: maskedValue } }, input.value as keyof CompanyInterface)
                              }}
                              value={String(handleViewValue(input.value as keyof CompanyInterface))}
                            />
                    }
                  </InputDiv>
                )}
            </SectionDiv>


          )}
          <SectionDiv style={{ flexDirection: 'column' }}>
            <SectionHeaderRow>
              <SectionTitle>Contatos</SectionTitle>
              <Plus strokeWidth={2.5} size={18} color="#0091d4" style={{ cursor: 'pointer' }} onClick={handleNewContact} />
            </SectionHeaderRow>
            {
              newContact ?
                <><LineContainer>
                  {contactInputs.map((input) => (
                    <InputDiv key={input.field} style={{ gridArea: input.field, marginLeft: '0.5rem' }}>
                      <InputLabel>{input.label}</InputLabel>
                      <InputData
                        type={input.type}
                        onChange={(e) => {
                          handleEditContat(input.field, input.field === 'phone' ? maskPhone(e.target.value) : e.target.value)
                        }}
                        placeholder='Digite aqui...'
                        value={
                          input.field === 'name' ? contactForm.name :
                            input.field === 'email' ? contactForm.email :
                              input.field === 'phone' ? contactForm.phone : ''
                        }
                      />
                    </InputDiv>
                  ))}
                  <OptionsContainer style={{ gridArea: 'save', paddingTop: '0.45rem', cursor: 'pointer', paddingLeft: '0.35rem' }}><Save onClick={handleAddContact} size={18} color="#0091d4" strokeWidth={1.5} /></OptionsContainer>
                </LineContainer></>
                :
                null
            }
            <ContactsContainer>
              {formData.contacts.length === 0 ? (
                <EmptyContactsMessage>
                  Nenhum contato cadastrado ainda. Clique no ícone + para adicionar um novo contato.
                </EmptyContactsMessage>
              ) : (
                formData.contacts.map((contact, index) => (
                  <ContactCard key={index}>
                    <ContactHeader>
                      <ContactName>{contact.name}</ContactName>
                      <button
                        onClick={() => handleRemoveContact(index)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#dc3545',
                          cursor: 'pointer',
                          padding: '0.3rem',
                          borderRadius: '4px',
                          fontSize: '0.8rem',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#f8d7da';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        title="Remover contato"
                      >
                        ✕
                      </button>
                    </ContactHeader>
                    <ContactInfo>
                      <ContactField>
                        <ContactLabel>Email:</ContactLabel>
                        <ContactValue>{contact.email}</ContactValue>
                      </ContactField>
                      <ContactField>
                        <ContactLabel>Telefone:</ContactLabel>
                        <ContactValue>{contact.phone}</ContactValue>
                      </ContactField>
                    </ContactInfo>
                  </ContactCard>
                ))
              )}
            </ContactsContainer>
          </SectionDiv>
          <SectionDiv style={{ flexDirection: 'column' }}>
            <SectionHeaderRow style={{ marginBottom: 0 }}>
              <SectionTitle>Usuários vinculados</SectionTitle>
            </SectionHeaderRow>
            <CompactUserSelectWrap>
              <UserSelect<{ id: number, name: string }>
                key={userSelectKey}
                label=''
                apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/findAll`}
                displayField='name'
                value={null}
                onChange={handleAddLinkedUser}
              />
            </CompactUserSelectWrap>
            <LinkedUsersTagsContainer>
              {formData.linkedUsers.length === 0 ? (
                <EmptyContactsMessage>
                  Nenhum usuário vinculado ainda. Selecione um usuário para criar o vínculo.
                </EmptyContactsMessage>
              ) : (
                formData.linkedUsers.map((user) => (
                  <LinkedUserTag key={user.id}>
                    {user.name}
                    <button
                      type="button"
                      onClick={() => handleRemoveLinkedUser(user.id)}
                    >
                      x
                    </button>
                  </LinkedUserTag>
                ))
              )}
            </LinkedUsersTagsContainer>
          </SectionDiv>

        </FormDataDiv>

        <BottomDiv>
          <ButtonContainer>
            {companyId ? (
              <ButtonDiv className="delete" onClick={() => { setDeleteError(null); setShowConfirm(true) }}>Excluir</ButtonDiv>
            ) : null}
            <ButtonDiv onClick={(() => navigate('..'))} className='cancel'>Cancelar</ButtonDiv>
            <ButtonDiv onClick={companyId ? handleEdit : handleSubmit}>
              <img src={plus}
              />
              {companyId ? 'Editar' : 'Cadastrar'}
            </ButtonDiv>
          </ButtonContainer>
        </BottomDiv>
      </Container>
      <ConfirmationModal
        isOpen={showConfirm}
        title="Excluir Empresa"
        message={deleteError ? deleteError : 'Tem certeza que deseja excluir esta empresa? Esta ação não poderá ser desfeita.'}
        actions={
          deleteError ? [
            {
              label: 'Fechar',
              onClick: () => { setShowConfirm(false); setDeleteError(null) },
              variant: 'outline' as const
            }
          ] : [
            {
              label: 'Cancelar',
              onClick: () => { setShowConfirm(false); setDeleteError(null) },
              variant: 'outline' as const
            },
            {
              label: 'Excluir',
              onClick: handleDeleteConfirm,
              variant: 'danger' as const
            }
          ]
        }
      />
    </ModalTest>
  )
}

export default AddCompanyModal